import { useParams } from 'react-router-dom';

import { Alert, Skeleton, useMediaQuery } from '@mui/material';
import OTable from '@src/shared/OTable';

import { ATTENDEES_COLUMNS } from './AttendeesColumns';
import { IAttendee, IAttendeeFilters } from '@src/webinar/types';
import { useWebinarAttendees } from '@src/hooks';
import AttendeesAccordion from '../Components/AttendeesAccordion';

interface AttendeesTableProps {
  filteredAttendees: IAttendeeFilters;
  tableRef: any;
  setSelectedAttendees: (selectedAttendees: IAttendee[]) => void;
}

function AttendeesTable({ filteredAttendees, tableRef, setSelectedAttendees }: AttendeesTableProps) {
  const { id } = useParams();
  const isMobile = useMediaQuery('(max-width:768px)');

  const { data, isLoading, isError, fetchNextPage, hasNextPage } = useWebinarAttendees(id || '', filteredAttendees);
  const isEmptyFilters = Object.values(filteredAttendees).every(
    (value) =>
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'string' && value === '') ||
      value === null ||
      value === undefined
  );

  if (isLoading) return <Skeleton width="100%" height={500} />;
  if (isError) return <Alert severity="error">Error loading attendees.</Alert>;
  if (isMobile) {
    return (
      <AttendeesAccordion
        data={data || []}
        setSelectedAttendees={setSelectedAttendees}
        hasLoadMore={hasNextPage}
        loadMore={fetchNextPage}
        tableRef={tableRef}
        isEmptyFilters={isEmptyFilters}
      />
    );
  }

  return (
    <OTable
      columns={ATTENDEES_COLUMNS}
      data={data || []}
      hasLoadMore={hasNextPage}
      isEmptyFilters={isEmptyFilters}
      loadMore={fetchNextPage}
      tableRef={tableRef}
      setSelectedRows={setSelectedAttendees}
    />
  );
}

export default AttendeesTable;
